import { ReactNode } from 'react'
import { YStack, View } from 'tamagui'
import { ModuleContainer } from './ModuleContainer'
import { ICourseModulesNodes } from '@dtos/Course'
import { filterAvailableModules } from '@utils/courseModules'

export { filterAvailableModules }

// O ModuleContainer compensa este padding com margem negativa: ele só se
// alinha dentro deste wrapper.
export function CourseModulesWrapper({
  children,
  id,
  flush = false,
}: {
  children: ReactNode
  id: string
  /** Seção entre outras seções (home focada): o espaço vertical vem do gap da tela. */
  flush?: boolean
}) {
  return (
    <YStack
      bg="$bg-page"
      p={'$size.spacing-xs'}
      {...(flush && { paddingVertical: 0 })}
      $gtSm={{
        padding: '$size.spacing-md',
        paddingTop: 0,
        ...(flush && { paddingBottom: 0 }),
      }}
      $gtMd={{
        padding: '$size.spacing-xsl',
        paddingTop: 0,
        paddingBottom: 0,
      }}
      id={id}
    >
      {children}
    </YStack>
  )
}

interface ICourseModuleSectionProps {
  module: ICourseModulesNodes
  index: number
  isLastModuleOfData?: boolean
  onLoadMore?: () => void
  canLoadMoreSubmodules: boolean
  onLoadMoreSubmodules?: () => void
  showLessonTitle?: boolean
  /** Módulo sozinho entre outras seções: sem respiro nas pontas. */
  flush?: boolean
}

export function CourseModuleSection({
  module,
  index,
  isLastModuleOfData,
  onLoadMore,
  canLoadMoreSubmodules,
  onLoadMoreSubmodules,
  showLessonTitle = true,
  flush = false,
}: ICourseModuleSectionProps) {
  const availableSubmodules = filterAvailableModules(module.courseModules || [])

  const moduleHasContent = module.courseContentsCount > 0

  return (
    <View>
      <ModuleContainer
        module={module}
        isLastModuleOfData={isLastModuleOfData}
        displayBorder={index === 0}
        onLoadMoreCallBack={onLoadMore}
        isLastSubmodule={moduleHasContent}
        isFirstModuleOfCourse={index === 0}
        showLessonTitle={showLessonTitle}
        flushTop={flush}
        flushBottom={flush && availableSubmodules.length === 0}
      />
      {availableSubmodules.map((submodule, submoduleIndex) => {
        const isFirstModule = index === 0
        const isLastSubmodule =
          submoduleIndex === availableSubmodules.length - 1

        return (
          <ModuleContainer
            key={submodule.id}
            module={submodule}
            parentCourseModuleId={submodule.parentCourseModule?.id}
            displayBorder
            isLastSubmodule
            fatherHasContent={isFirstModule}
            isSubmodulesList={true}
            isLastOfSubmodulesList={isLastSubmodule && canLoadMoreSubmodules}
            onLoadMoreCallBack={onLoadMoreSubmodules}
            showLessonTitle={showLessonTitle}
            flushBottom={
              flush && submoduleIndex === availableSubmodules.length - 1
            }
          />
        )
      })}
    </View>
  )
}
